// utils
import { formatDocument, formatMobile } from "./formatters";

// Monta os itens (rótulo + valor) exibidos no card de um participante a partir do
// `info` do attendee e dos campos do formulário do evento (configurations.fields).
// Campos do formulário vêm primeiro, na ordem configurada; propriedades extras do
// `info` vêm depois com rótulo "humanizado"; chaves técnicas ficam de fora.

// chaves internas do checkout, sem valor para o operador
const HIDDEN_KEYS = ["productId", "groups", "sessionId", "seatId", "password", "firstAccess"];
const isHidden = (key) => HIDDEN_KEYS.includes(key) || key.startsWith("utm");

// "cargo_participante" -> "Cargo participante"; "seatNumber" -> "Seat number"
export function humanize(key) {
  const text = String(key)
    .replace(/_/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .toLowerCase()
    .trim();
  return text.charAt(0).toUpperCase() + text.slice(1);
}

// valor legível para exibição; vazio vira "" (o item é omitido)
export function formatValue(value, type) {
  if (value === null || value === undefined) return "";
  if (typeof value === "boolean") return value ? "Sim" : "Não";
  if (Array.isArray(value)) return value.map((v) => formatValue(v)).filter(Boolean).join(", ");
  if (typeof value === "object") return JSON.stringify(value);

  const text = String(value).trim();
  if (text === "") return "";
  if (type === "cpf" || type === "cnpj") return formatDocument(text);
  if (type === "mobile") return formatMobile(text);
  return text;
}

export function buildAttendeeItems(info = {}, fields = []) {
  const data = info && typeof info === "object" ? info : {};
  const items = [];
  const used = new Set();

  fields.forEach((field) => {
    if (!(field.name in data) || isHidden(field.name)) return;
    used.add(field.name);
    const value = formatValue(data[field.name], field.type);
    if (value) items.push({ name: field.name, label: field.label || humanize(field.name), value });
  });

  Object.keys(data)
    .filter((key) => !used.has(key) && !isHidden(key))
    .sort()
    .forEach((key) => {
      const value = formatValue(data[key]);
      if (value) items.push({ name: key, label: humanize(key), value });
    });

  return items;
}

// chaves do customer_info que já têm coluna própria na transação e já aparecem no card
// Comprador pelas colunas (mesma lista que a payment-processing-api ignora ao mesclar)
const CUSTOMER_COLUMN_KEYS = ["name", "email", "document", "mobile", "address"];

// Itens do card Comprador vindos do `customer_info` da transação (formulário de cobrança
// completo), rotulados por configurations.customer.fields no mesmo padrão do participante.
// Só os campos customizáveis: os que já saem das colunas ficam de fora para não duplicar.
// Sem customer_info (compras antigas), devolve [].
export function buildCustomerItems(customerInfo, fields = []) {
  return buildAttendeeItems(customerInfo, fields).filter(
    (item) => !CUSTOMER_COLUMN_KEYS.includes(item.name)
  );
}
